// eslint-disable-next-line import/no-unresolved
import { Box } from '@modusign/design-system';
import * as CSS from 'csstype';
import { ResponsiveValue } from 'styled-system';

import CenterLoadingSpinner from '@app/components/CenterLoadingSpinner';

interface ResizableCenterLoadingSpinnerProps {
  height: ResponsiveValue<CSS.Property.Height>;
  width?: ResponsiveValue<CSS.Property.Width>;
}

export default function ResizableCenterLoadingSpinner(props: ResizableCenterLoadingSpinnerProps) {
  return (
    <Box width="100%" {...props} position="relative">
      <CenterLoadingSpinner size={40} />
    </Box>
  );
}
